<template>
  <div>
    <list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="list-box">
        <kevideo :list="list" />
      </div>
    </list>
  </div>
</template>
<script>
import kevideo from "../../../components/kcvideo.vue";
import { List } from "vant";

export default {
  name: "collection",
  props: {},
  components: { kevideo, List},

  data() {
    return {
      list: [],
      page: 1,
      finished: false,
      loading: false,
    };
  },
  created() {},
  methods: {
    getList() {
      this.api.myCollection({ page: this.page }).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    onLoad() {
      this.getList();
      this.page++;
    },
  },
};
</script>
<style lang="less" scoped>
.list-box {
  padding: 0 0.2rem;
}
</style>
